export default class AuthUser {
  id;
  roles;
  name;

  constructor(opts) {
    Object.assign(this, opts);
  }
}
